export default __webpack_public_path__ + "static/media/LogoBlanc.ff7cbb3c.png";